module.exports = __webpack_public_path__ + "static/media/tier1.c8ba6d88.svg";